module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "home-module content"
  }, _vm._l((_vm.data), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "goods-item",
      on: {
        "click": function($event) {
          return _vm.gotoPage(item)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "atl": item.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-content-footer",
      style: ({
        background: _vm.isShowBg ? '#f8ebe4' : ''
      })
    }, [_c('div', {
      staticClass: "tit"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "pri"
    }, [_c('span', {
      staticClass: "pri-1"
    }, [_vm._v("￥" + _vm._s(item.mktprice))]), _c('span', {
      staticClass: "pri-2"
    }, [_vm._v("会员价")]), _c('span', {
      staticClass: "pri-3"
    }, [_vm._v("￥" + _vm._s(item.price))])])])])
  }), 0), _vm._v(" "), (_vm.hasMore) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px",
      "color": "#858585",
      "font-size": "18px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.moreHandler
    }
  }, [_c('span', [_vm._v(" 加载更多>>")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1347b44a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/perference-sale/list.vue
// module id = 1534
// module chunks = 1